(function(){
  var c=window.vatConfig||{priceMode:"ex",vatRate:0.25,defaultMode:"excl",moneyFormat:"{{amount_no_decimals}} kr"};
  // Preference is stored per price-mode so a Swedish ex-VAT choice doesn't silently carry
  // over into an inclusive market (an EU consumer must default to a VAT-inclusive price).
  var K="vat_display_mode:"+(c.priceMode||"ex");
  function gM(){try{return localStorage.getItem(K)||c.defaultMode;}catch(e){return c.defaultMode;}}
  function sM(m){try{localStorage.setItem(K,m);}catch(e){}}
  function fM(cents){
    var a=(cents/100).toFixed(2);
    var nd=Math.round(cents/100);
    var ac=a.replace(".",",");
    var s=c.moneyFormat;
    s=s.replace("{{amount_with_comma_separator}}",ac.replace(/\d(?=(\d{3})+,)/g,"$& "));
    s=s.replace("{{amount_no_decimals_with_comma_separator}}",String(nd).replace(/\d(?=(\d{3})+$)/g,"$& "));
    s=s.replace("{{amount_no_decimals}}",String(nd).replace(/\d(?=(\d{3})+$)/g,"$& "));
    s=s.replace("{{amount}}",a.replace(/\d(?=(\d{3})+\.)/g,"$& "));
    return s;
  }
  var reclaims=0;
  function reclaimFromTaxApp(){
    // Safety net: this toggle is the single source of truth for incl/excl (moms) display.
    // A third-party B2B "tax display" app can hide the theme price (inline display:none +
    // data-b2b-tax-price-suppressed) and inject its own .b2b-tax-display-replacement, which
    // this toggle can't update — leaving the price frozen. If that ever happens, undo it
    // (mirrors the app's own restore) so the theme price stays visible and toggleable.
    // No-op unless those markers are present.
    var sup=document.querySelectorAll("[data-b2b-tax-price-suppressed]");
    var reps=document.querySelectorAll(".b2b-tax-display-replacement");
    if(!sup.length&&!reps.length)return;
    // Cap it: if the app re-suppresses every time we restore, don't ping-pong forever.
    if(++reclaims>20)return;
    for(var i=0;i<sup.length;i++){
      var prev=sup[i].getAttribute("data-b2b-tax-prev-display");
      sup[i].style.display=(prev!=null&&prev!=="")?prev:"";
      sup[i].removeAttribute("data-b2b-tax-price-suppressed");
      sup[i].removeAttribute("data-b2b-tax-prev-display");
    }
    for(var j=0;j<reps.length;j++){if(reps[j].parentNode)reps[j].parentNode.removeChild(reps[j]);}
  }
  // Convert the price Shopify rendered into the requested display mode.
  // 'ex'  -> data-price-base excludes VAT (Sweden): add it for "incl".
  // 'inc' -> data-price-base already includes the destination country's VAT (EU/UK/NO):
  //          divide it out for "excl". Dividing the *rendered* price is deliberate — it is
  //          exactly what checkout does when VAT is lifted, so the two always agree.
  function convert(base,mode){
    var r=c.vatRate;
    if(!r||r<=0)return base;
    if(c.priceMode==="inc")return mode==="incl"?base:Math.round(base/(1+r));
    return mode==="incl"?Math.round(base*(1+r)):base;
  }
  // Mode-specific wording (cart tax note, checkout hint — snippets/cart-vat-note.liquid):
  // show the variant for the current mode, hide the rest.
  function showModeText(m){
    var els=document.querySelectorAll("[data-vat-show]");
    for(var i=0;i<els.length;i++){els[i].hidden=els[i].getAttribute("data-vat-show")!==m;}
  }
  function run(){
    reclaimFromTaxApp();
    // 'none' = no VAT applies to this destination (US/CA). Shopify already rendered the
    // correct price, duties included. Touching it could only make it wrong.
    if(c.priceMode==="none")return;
    var m=gM();
    var els=document.querySelectorAll(".vat-adjusted[data-price-base]");
    for(var i=0;i<els.length;i++){
      var b=parseInt(els[i].getAttribute("data-price-base"),10);
      if(isNaN(b))continue;
      els[i].textContent=fM(convert(b,m));
    }
    var notes=document.querySelectorAll("[data-vat-note]");for(var k=0;k<notes.length;k++){notes[k].textContent=m==="incl"?(c.labelIncl||"Inkl. moms"):(c.labelExcl||"Exkl. moms");}
    showModeText(m);
    var btns=document.querySelectorAll("[data-vat-toggle]");
    var t=document.getElementById("vat-toggle");
    if(t) t.setAttribute("data-mode", m);
    for(var j=0;j<btns.length;j++){
      var act=btns[j].getAttribute("data-vat-toggle")===m;
      btns[j].setAttribute("aria-pressed",act?"true":"false");
      if(act)btns[j].classList.add("vat-toggle__btn--active");
      else btns[j].classList.remove("vat-toggle__btn--active");
    }
  }
  function init(){
    var t=document.getElementById("vat-toggle");
    if(!t)return;
    t.addEventListener("click",function(e){
      var b=e.target.closest("[data-vat-toggle]");
      if(!b)return;
      sM(b.getAttribute("data-vat-toggle"));
      run();
    });
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){init();run();});
  }else{init();run();}
  document.addEventListener("cart:updated",function(){run();});
  document.addEventListener("cart:change",function(){run();});
  // The theme fires neither event above. The cart drawer and cart page re-render by
  // swapping in fresh section HTML (assets/cart-items.js, assets/cart-drawer.js), and that
  // HTML carries the server default, not the shopper's choice — so after an add-to-cart in
  // Inkl. mode the drawer showed ex-VAT prices. Re-apply whenever new VAT nodes appear.
  // run() itself only swaps text nodes and toggles attributes, so it can't re-trigger this.
  var SEL=".vat-adjusted[data-price-base],[data-vat-note],[data-vat-show]";
  var queued=false;
  function queue(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){queued=false;run();});
  }
  if(window.MutationObserver){
    new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var added=muts[i].addedNodes;
        for(var j=0;j<added.length;j++){
          var n=added[j];
          if(n.nodeType===1&&(n.matches(SEL)||n.querySelector(SEL))){queue();return;}
        }
      }
    }).observe(document.body,{childList:true,subtree:true});
  }
  window.vatToggle={recalcPrices:run,getMode:gM,setMode:sM};
})();
